'use strict';

window.VariationsWidget = window.VariationsWidget || {};
const { VariationsWidget } = window;
const { h, render } = require('phy');
const Traits = require('../components/Traits.js');

// This initiates the client-side widget
VariationsWidget.init = ({ variations }, done) => {
  if (variations) {
    // hydrate
    render(
      h(Traits, variations),
      document.getElementById('variation-container'),
      document.getElementById('variation-selector-widget')
    );
  }

  return done();
};

module.exports = VariationsWidget;
